module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/9a7bbbbebc4b2b303d426f8a7f963298.gif";